import { render, staticRenderFns } from "./personal-detail.vue?vue&type=template&id=0f6889c4&scoped=true"
import script from "./personal-detail.vue?vue&type=script&lang=js"
export * from "./personal-detail.vue?vue&type=script&lang=js"
import style0 from "./personal-detail.vue?vue&type=style&index=0&id=0f6889c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6889c4",
  null
  
)

export default component.exports